import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePassword = () => {
  const [f, setF] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (f.next.length < 8) return toast.error("New password must be at least 8 characters");
    if (f.next !== f.confirm) return toast.error("Passwords don't match");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current || null, new_password: f.next });
      toast.success("Password changed");
      setF(EMPTY);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Could not change password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="rounded-2xl bg-white border border-slate-200 p-5" data-testid="change-password-section">
      <h2 className="font-extrabold text-lg text-slate-900 flex items-center gap-2"><KeyRound size={16} className="text-emerald-600" /> Change password</h2>
      <div className="grid sm:grid-cols-3 gap-3 mt-3">
        <div><Label>Current password</Label><Input type="password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} data-testid="change-pw-current" /></div>
        <div><Label>New password</Label><Input type="password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} data-testid="change-pw-new" /></div>
        <div><Label>Confirm new</Label><Input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="change-pw-confirm" /></div>
      </div>
      <Button className="mt-3 bg-emerald-600 hover:bg-emerald-700 text-white" onClick={submit} disabled={saving} data-testid="change-pw-submit">
        {saving ? "Saving…" : "Update password"}
      </Button>
    </section>
  );
};
